import { render, staticRenderFns } from "./Signatures.vue?vue&type=template&id=476589ba&scoped=true"
import script from "./Signatures.vue?vue&type=script&lang=js"
export * from "./Signatures.vue?vue&type=script&lang=js"
import style0 from "./Signatures.vue?vue&type=style&index=0&id=476589ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476589ba",
  null
  
)

export default component.exports